import { useEffect, useRef } from 'react';

// 쿠팡 파트너스 다이나믹 배너(G 위젯).
// new PartnersCoupang.G(...) 는 자신을 호출한 <script>(document.currentScript) 위치에
// iframe 을 삽입한다. 그래서 g.js 와 생성 스크립트를 ref 컨테이너 안에 주입해
// 배너가 항상 이 div 안에 렌더되도록 한다.
export default function CoupangBanner({
  id = 1000886,
  trackingCode = 'AF3750114',
  subId = null,
  template = 'carousel',
  width = '120',
  height = '520',
}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.innerHTML = ''; // StrictMode 재실행/리렌더 시 배너 중복 방지

    const lib = document.createElement('script');
    lib.src = 'https://ads-partners.coupang.com/g.js';
    lib.async = true;

    const init = document.createElement('script');
    init.text = `new PartnersCoupang.G(${JSON.stringify({
      id,
      trackingCode,
      subId,
      template,
      width,
      height,
    })});`;

    // g.js 로드 후 컨테이너 안에서 위젯 생성 → iframe 이 el 내부에 삽입됨
    lib.onload = () => {
      if (ref.current) el.appendChild(init);
    };
    el.appendChild(lib);

    return () => {
      el.innerHTML = '';
    };
  }, [id, trackingCode, subId, template, width, height]);

  return <div className="coupang-banner" ref={ref} aria-hidden="true" />;
}
